/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'orgs': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M15 29c7.732 0 14-6.268 14-14S22.732 1 15 1 1 7.268 1 15s6.268 14 14 14zm0 1c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z" _fill="#fff"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M20 7H10v15h10V7zM9 6v17h12V6H9z" _fill="#fff"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M17 8v3h2V8h-2zM14 8v3h2V8h-2zM11 8v3h2V8h-2zM17 12v3h2v-3h-2zM14 12v3h2v-3h-2zM11 12v3h2v-3h-2zM17 16v3h2v-3h-2zM14 16v3h2v-3h-2zM11 16v3h2v-3h-2z" _fill="#fff"/>'
  }
})
